var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/DifficultConditions/ConditionItem.tsx";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { Box } from '@gmini/ui-kit/lib/Box';
import React, { useCallback, useEffect } from 'react';
import { FormulaInput } from '@gmini/ui-kit/lib/FormulaInput';
import { TextField } from '@gmini/ui-kit';
import { ConditionLayout } from "./ConditionLayout";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var operators = [];
export var ConditionItem = /*#__PURE__*/React.memo(function (_ref) {
  var onValidate = _ref.onValidate,
      allSuggestions = _ref.allSuggestions,
      _ref$suggestionsInFor = _ref.suggestionsInFormula,
      suggestionsInFormula = _ref$suggestionsInFor === void 0 ? [] : _ref$suggestionsInFor,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      idx = _ref.idx,
      formula = _ref.formula,
      unit = _ref.unit,
      calculationId = _ref.calculationId,
      name = _ref.name,
      errorName = _ref.errorName,
      readonly = _ref.readonly;
  // eslint-disable-next-line no-empty-function
  var validate = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []); // eslint-disable-next-line no-empty-function

  var formulaHandler = useCallback(function (value) {}, []); // eslint-disable-next-line no-empty-function

  var onChangeFormula = React.useCallback(function () {}, []);
  var onBlurFormula = React.useCallback(function () {
    validate();
  }, [validate]);
  var onClearFormula = React.useCallback(function () {
    formulaHandler('');
  }, [formulaHandler]); // eslint-disable-next-line no-empty-function

  var onChangeUnit = React.useCallback(function (value) {}, []); // eslint-disable-next-line no-empty-function

  var onChangeName = useCallback(function (value) {}, []);
  useEffect(function () {
    validate();
  }, [validate]);
  var isSmallWidth = true;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ConditionLayout, {
      disabled: !!disabled,
      header: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        flexDirection: isSmallWidth ? 'column' : 'row',
        style: {
          gap: '14px 16px'
        },
        children: [/*#__PURE__*/_jsx(Box, {
          width: "100%",
          children: /*#__PURE__*/_jsx(TextField, {
            value: name,
            onChange: onChangeName,
            placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438",
            disabled: disabled || readonly,
            background: "#fff",
            error: Boolean(errorName)
          })
        }), /*#__PURE__*/_jsx(Box, {
          width: isSmallWidth ? '100%' : '110px',
          children: /*#__PURE__*/_jsx(TextField, {
            value: unit,
            onChange: onChangeUnit,
            placeholder: "\u0435\u0434.\u0438\u0437\u043C.",
            disabled: disabled || readonly,
            background: "#fff"
          })
        })]
      }),
      formulaInput: /*#__PURE__*/_jsx(FormulaInput, {
        sourceStr: formula,
        allSuggestions: allSuggestions,
        operators: operators,
        onChange: onChangeFormula,
        onBlur: onBlurFormula,
        onClear: onClearFormula,
        suggestionsInFormula: suggestionsInFormula,
        disabled: disabled || readonly,
        readonly: readonly
      }),
      noteText: null
    })
  });
});
ConditionItem.displayName = 'ConditionItem';